<template>
  <div>
    <a-table :columns="columns" :data-source="data">
      <template slot="name" slot-scope="text">
        <a>{{ text }}</a>
      </template>
      <span slot="courseDetail" slot-scope="text">
        <a @click="getStudent(text)">查看</a>
      </span>
    </a-table>
    <a-modal
      title="上课情况"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
      :footer="null"
    >
      <a-table :columns="columns2" :data-source="data2">
        <template slot="name" slot-scope="text">
          <a>{{ text }}</a>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { getListByClassId, getStudentDetailsList } from '@/api/api';
import Bus from './bus';

export default {
  name: 'DetailModal',
  data() {
    const columns = [
      {
        title: '课程主题',
        dataIndex: 'theme',
        align: 'center'
      },
      {
        title: '授课时间',
        dataIndex: 'startTime',
        align: 'center'
      },
      {
        title: '课程内容',
        align: 'center',
        dataIndex: 'name'
      },
      {
        title: '课程时长(分钟)',
        align: 'center',
        dataIndex: 'last'
      },
      {
        title: '上课情况',
        align: 'center',
        dataIndex: 'address',
        children: [
          {
            title: '学员人数',
            dataIndex: 'populationNum',
            align: 'center'
          },
          // {
          //   title: '签到数',
          //   align: 'center',
          //   dataIndex: 'signNum',
          // },
          {
            title: '作业数',
            align: 'center',
            dataIndex: 'workNum'
          },
          {
            title: '笔记数',
            dataIndex: 'exerciseNum',
            align: 'center'
          },
          {
            title: '查看详情',
            align: 'center',
            width: 100,
            dataIndex: 'courseId',
            scopedSlots: {
              customRender: 'courseDetail'
            }
          }
        ]
      }
    ];
    const columns2 = [
      {
        title: '学员',
        align: 'center',
        dataIndex: 'realName',
        customRender: function(text, record, index) {
          if (!text) {
            return '--';
          } else {
            return text;
          }
        }
      },
      // {
      //   title: '签到',
      //   align: 'center',
      //   dataIndex: 'hasSign',
      //   customRender: function (text, record, index) {
      //     if (text === 0) {
      //       return '×'
      //     } else if (text == 1) {
      //       return '√'
      //     }
      //   }
      // },
      {
        title: '作业',
        align: 'center',
        dataIndex: 'workNum',
        customRender: function(text, record, index) {
          if (!text) {
            return '0';
          } else {
            return text;
          }
        }
      },
      {
        title: '笔记',
        align: 'center',
        dataIndex: 'noteNum',
        customRender: function(text, record, index) {
          if (!text) {
            return '0';
          } else {
            return text;
          }
        }
      }
    ];
    return {
      data: [],
      columns,
      columns2,
      data2: [],
      visible: false
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    getList(ClassId) {
      console.log('============');
      this.data = [];
      getListByClassId({
        class_id: ClassId
      }).then(res => {
        if (res.success) {
          res.result.dayList.forEach(e => {
            e.forEach(item => {
              this.data.push(item);
            });
          });
        }
      });
    },
    getStudent(courseId) {
      getStudentDetailsList({
        class_id: this.ClassId,
        course_id: courseId
      }).then(res => {
        if (res.success) {
          this.data2 = res.result.studendList;
        }
      });
      this.visible = true;
    }
  },
  mounted() {
    console.log('niahao');
    // Bus.$on("getList", (e) => {
    //     this.ClassId=e
    // })
    this.ClassId = sessionStorage.getItem('CLASSID');
    console.log(this.ClassId);
    this.getList(this.ClassId);
  }
};
</script>
